import { render, staticRenderFns } from "./editBoardManage.vue?vue&type=template&id=2038d470"
import script from "./editBoardManage.vue?vue&type=script&lang=js"
export * from "./editBoardManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports